import {
  Heading,
  Text,
  Card,
  Container,
  Stack,
  useBreakpoint
} from '@leroy-merlin-br/backyard-react'
import { useStats } from 'react-instantsearch'

import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import * as S from './styled'

const TopContent = () => {
  const { nbHits } = useStats()
  const { query } = useAlgoliaContext()
  const totalCount = nbHits.toLocaleString()
  const { breakpoint } = useBreakpoint() as unknown as { breakpoint: string }
  const isMobile = ['untilKilo', 'kilo'].includes(breakpoint)

  const topContentTitle = query.trim() === '' ? 'Produtos Recomendados' : query

  return (
    <Container data-cy="top-content">
      <S.CardWrapper>
        <Card>
          <S.TopContent>
            <Stack space={isMobile ? 'bit' : 'byte'}>
              <Heading size={isMobile ? 'tera' : 'exa'} as="h1" noMargin>
                {topContentTitle}{' '}
              </Heading>
              <Text size={isMobile ? 'kilo' : 'mega'} color="n600" noMargin>
                {`${totalCount} ${
                  totalCount === '1' ? 'Resultado' : 'Resultados'
                }`}
              </Text>
            </Stack>
          </S.TopContent>
        </Card>
      </S.CardWrapper>
    </Container>
  )
}

export default TopContent
